import createHttpClient from './httpClient'

const baseUrl = new URL('/api/v1/customerresources', process.env.VUE_APP_PUBLIC_SERVICE_BASE_URL).href
const httpClient = createHttpClient(baseUrl)

const billingBaseUrl = new URL('/api/v1/billing', process.env.VUE_APP_INTERNAL_SERVICE_BASE_URL).href
const billingHttpClient = createHttpClient(billingBaseUrl)

const CreditCardsApi = {
  getChargeReceipts(buyerId) {
    const url = `user-account/buyer/${buyerId}/charge-receipts`
    return httpClient.get(url)
  },

  getAllCharges({ filter, skip, limit }) {
    let url = 'admin/credit-cards/charges?'
    const params = []
    if (filter) {
      params.push(`filter=${encodeURIComponent(filter)}`)
    }

    if (skip !== undefined && skip !== null) {
      params.push(`skip=${skip}`)
    }

    if (limit !== undefined && limit !== null) {
      params.push(`limit=${limit}`)
    }

    url += params.join('&')
    return billingHttpClient.get(url)
  },

  getAllChargesTotal(filter) {
    let url = 'admin/credit-cards/charges/total'
    if (filter) {
      url += `?filter=${encodeURIComponent(filter)}`
    }

    return billingHttpClient.get(url)
  }
}

export default CreditCardsApi
